import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { extractResumeDataDocumentSection } from "../../../hooks/useResumeDocumentSection";
import { extractResumeProperties } from "../../../hooks/useResumeProperties";

export default function CommonPdfBusinessSkillsSection( { resumeData, translations } ) {
    const { businessSkills } = extractResumeDataDocumentSection( resumeData );
    const { isAlcyone, documentLanguage } = extractResumeProperties( resumeData );

    const themeColor = isAlcyone ? '#09B4BF' : '#0B86C8';

    const styles = StyleSheet.create( {
        section: {
            flexDirection: 'row',
            marginBottom: 2,
            fontSize: 10,
        },
        leftColumn: {
            width: "30%",
            justifyContent: "flex-end",
            alignItems: "flex-end"
        },
        rightColumn: {
            width: "70%"
        },
        textStart: {
            fontFamily: "Verdana, sans-serif",
            fontSize: "9px",
            margin: 0,
            marginTop: 4,
            textAlign: "right"
        },
        divider: {
            width: "100%",
            height: 5,
            backgroundColor: "#009999",
            marginVertical: 4
        },
        sectionCompetence: {
            flexDirection: 'row',
            flexWrap: 'wrap',
        },
        categoryColumn: {
            width: '25%',
        },
        competencesColumn: {
            width: '75%',
        },
        category: {
            fontSize: 8,
            color: themeColor,
            marginBottom: 1,
            marginTop: 3,
            textAlign: 'start',
            fontWeight: 'bold',
        },
        competence: {
            width: '50%',
            marginBottom: 0,
            flexDirection: 'row',
            alignItems: 'center',
        },
        competenceName: {
            fontSize: 8,
            margin: 1,
            width: "40%",
            marginRight: 5,
            marginLeft: 2,
            textAlign: 'start',
        },
        competenceDuration: {
            fontSize: 6,
            width: "40px",
        },
        ratingContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            width: "60px"
        },
        dash: {
            fontSize: 12,
            marginRight: 2,
        },
        dashActive: {
            color: themeColor,
        },
        dashInactive: {
            color: '#CCCCCC',
        },
        sectionTitle: {
            fontSize: 12,
            fontWeight: 'bold',
            marginBottom: 2,
            textTransform: 'uppercase',
            color: themeColor,
        },
        titleContainer: {
            flexDirection: 'row',
            alignItems: 'center',
        },
        line: {
            flexGrow: 1,
            height: 1,
            backgroundColor: themeColor,
            marginLeft: 5,
        },
        lineTitle: {
            height: 1,
            backgroundColor: "#979797",
            marginRight: 10,
            marginBottom: 5,
        }
    } );

    const DashRating = ( { rating } ) => (
        <View style={ styles.ratingContainer }>
            { [ 1, 2, 3, 4, 5 ].map( ( value ) => (
                <Text
                    key={ value }
                    style={ [
                        styles.dash,
                        value <= rating ? styles.dashActive : styles.dashInactive
                    ] }
                >
                    -
                </Text>
            ) ) }
        </View>
    );

    return (
        <View style={ { marginTop: 10 } }>
            <View style={ styles.titleContainer }>
                <Text style={ styles.sectionTitle }>
                    { translations.pdf.businessSkillsTitle }
                </Text>
                <View style={ styles.line }/>
            </View>
            { businessSkills
                .sort( ( a, b ) => a.order - b.order )
                .map( ( category, index ) => (
                    <View key={ index }>
                        <View style={ styles.sectionCompetence }>
                            <View style={ styles.categoryColumn }>
                                <Text style={ styles.category }>
                                    { category.category.translations[ documentLanguage ] }
                                </Text>
                            </View>
                            <View style={ styles.competencesColumn }>
                                <View style={ styles.sectionCompetence }>
                                    { category.competences
                                        .sort( ( a, b ) => a.order - b.order )
                                        .map( ( competence, subIndex ) => (
                                            <View key={ subIndex } style={ styles.competence }>
                                                <Text style={ styles.competenceName }>
                                                    { competence.translations[ documentLanguage ] }
                                                </Text>
                                                <DashRating rating={ competence.level }/>
                                                {/* TODO DURATION OF COMPETENCES   */ }
                                            </View>
                                        ) ) }
                                </View>
                            </View>
                        </View>
                        <View style={ { height: 1, backgroundColor: themeColor, marginVertical: 2 } }/>
                    </View>
                ) ) }
        </View>
    );
}
